"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _contents = _interopRequireDefault(require("./contents"));

var _vehicle = _interopRequireDefault(require("./vehicle"));

var _user = _interopRequireDefault(require("./user"));

var _modal = _interopRequireDefault(require("./modal"));

var _consts = require("./consts");

var _combineReducers;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _redux.combineReducers)((_combineReducers = {}, _defineProperty(_combineReducers, _consts.CONTENT_REDUCER_NAME, _contents["default"]), _defineProperty(_combineReducers, _consts.VEHICLE_REDUCER_NAME, _vehicle["default"]), _defineProperty(_combineReducers, _consts.USER_REDUCER_NAME, _user["default"]), _defineProperty(_combineReducers, "modal", _modal["default"]), _combineReducers));

exports["default"] = _default;